import styled from "@emotion/styled";
import { Grid2 } from "@mui/material";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  gap: 20px;

  @media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
    flex-direction: row;
  }
`;
export const GridItem = styled(Grid2)`
  flex-grow: 1;
`;
